import axios from 'axios';
import {buildQuery} from 'utils/QueryUtils';

export const findPatients = (headers, params) => {
  let query = buildQuery(params);
  return axios.get(`${process.env.REACT_APP_INFO_API_URL}/patients${query}`, {
    headers,
  });
};

export const findPatientById = (headers, id) => {
  return axios.get(`${process.env.REACT_APP_INFO_API_URL}/patients/${id}`, {
    headers,
  });
};

export const findPatientByMyself = (headers) => {
  return axios.get(`${process.env.REACT_APP_INFO_API_URL}/patients/myself`, {
    headers,
  });
};

export const createPatient = (headers, data) => {
  return axios.post(`${process.env.REACT_APP_INFO_API_URL}/patients`, data, {
    headers,
  });
};

export const uploadPhoto = (headers, id, data) => {
  return axios.put(
    `${process.env.REACT_APP_INFO_API_URL}/patients/${id}/photo`,
    data,
    {
      headers,
    },
  );
};

export const updatePatient = (headers, id, data) => {
  return axios.patch(
    `${process.env.REACT_APP_INFO_API_URL}/patients/${id}`,
    data,
    {
      headers,
    },
  );
};

export const deletePatient = (headers, id) => {
  return axios.delete(`${process.env.REACT_APP_INFO_API_URL}/patients/${id}`, {
    headers: headers,
  });
};

export const findTreatments = (headers, id, params) => {
  let query = buildQuery(params);
  return axios.get(
    `${process.env.REACT_APP_INFO_API_URL}/patients/${id}/treatments${query}`,
    {
      headers,
    },
  );
};

export const createTreatment = (headers, id, data) => {
  return axios.post(
    `${process.env.REACT_APP_INFO_API_URL}/patients/${id}/treatments`,
    data,
    {
      headers,
    },
  );
};

export const findVitals = (headers, id, params) => {
  let query = buildQuery(params);
  return axios.get(
    `${process.env.REACT_APP_INFO_API_URL}/patients/${id}/vitals${query}`,
    {
      headers,
    },
  );
};

export const createVital = (headers, id, data) => {
  return axios.post(
    `${process.env.REACT_APP_INFO_API_URL}/patients/${id}/vitals`,
    data,
    {
      headers,
    },
  );
};
